export default __webpack_public_path__ + "static/media/icoFacebook.c5dcc3eb.svg";